
<header class="site-header">
  <nav class="navbar navbar-expand-lg main-navbar">
    <div class="container-fluid px-3 px-lg-4">
      <a class="navbar-brand d-flex align-items-center gap-2" routerLink="/">
        <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
        <span class="brand-text">
          UMYO <span class="text-pink">ESPAÑOL</span>
          <small>DIRECTORY</small>
          <span class="tagline">FOR US. BY US. — POWERED BY UMYO.</span>
        </span>
      </a>

      <button class="menu-btn d-flex d-md-none navbar-toggler"
        type="button"
        (click)="isNavOpen = !isNavOpen"
        [attr.aria-expanded]="isNavOpen"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
      >
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 6h18M3 12h18M3 18h18"/>
        </svg>
      </button>

      <div class="navbar-collapse justify-content-center" id="navbarNav" [class.show]="isNavOpen">
        <ul class="navbar-nav main-nav">
          <li class="nav-item"><a class="nav-link active" routerLink="/home" (click)="isNavOpen = false">Home</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/directory" (click)="isNavOpen = false">Directory</a></li>
          <li class="nav-item"><a class="nav-link " routerLink="/packages" (click)="isNavOpen = false">Packages</a></li>
          <li class="nav-item"><a class="nav-link" href="/assets/creat-card/index.html" target="_self">Creat Card</a></li>
          <li class="nav-item"><a class="nav-link" routerLink="/hardship" (click)="isNavOpen = false">Hardship Incentives</a></li>
        </ul>
      </div>

      <div class="d-none d-md-flex align-items-center gap-2">
        <div class="lang-switch">
          <button type="button" class="lang-btn" [class.active]="lang === 'en'" (click)="setLang('en')">EN</button>
          <button type="button" class="lang-btn" [class.active]="lang === 'es'" (click)="setLang('es')">ES</button>
        </div>

        <a href="/?authTab=login#login" class="btn btn-outline-pink btn-sm-pad">{{ t.nav.login }}</a>
        <a href="/?authTab=register#register" class="btn btn-pink">{{ t.nav.register }}</a>
      </div>
    </div>
  </nav>
</header>

<!-- ============ HERO ============ -->
<section id="hero">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-7 col-md-7 hero-left">
        <span class="hero-kicker">{{ t.hero.kicker }}</span>

        <h1 class="hero-title">
          {{ t.hero.title1 }}<br>
          {{ t.hero.title2 }}<br>
          <span class="highlight">{{ t.hero.title3 }}</span>
        </h1>

        <p class="hero-subtitle">{{ t.hero.subtitle }}</p>

        <div class="hero-actions">
          <a href="/?authTab=register#register" class="btn btn-pink">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/><path d="M2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1"/><path d="M19 8v6M22 11h-6"/>
            </svg>
            {{ t.hero.register }}
          </a>
          <a href="/?authTab=login#login" class="btn btn-outline-pink">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 16l4-4-4-4"/><path d="M15 12H3"/><path d="M13 3h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5"/>
            </svg>
            {{ t.hero.login }}
          </a>
        </div>

        <div class="hero-stats">
          <div class="stat-box">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
            <div><h3>20,842+</h3><span>{{ t.hero.members }}</span></div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-box">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 9l1-5h16l1 5"/><path d="M3 9a2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0 2 2 0 0 0 4 0"/><path d="M5 9v10h14V9"/><path d="M9 21v-6h6v6"/>
            </svg>
            <div><h3>8,761+</h3><span>{{ t.hero.businesses }}</span></div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-box">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z"/>
            </svg>
            <div><h3>150+</h3><span>{{ t.hero.categories }}</span></div>
          </div>
          <div class="stat-divider"></div>
          <div class="stat-box">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s7-4.5 7-11V5l-7-3-7 3v6c0 6.5 7 11 7 11Z"/>
            </svg>
            <div><span>{{ t.hero.private }}</span></div>
          </div>
        </div>
      </div>
      <!-- right side: hero photo/flags illustration lives in the #hero background image (see CSS) -->
      <div class="col-lg-5 col-md-5"></div>
    </div>
  </div>
</section>

<!-- ============ SEARCH DIRECTORY ============ -->
<section id="header" class="search-section">
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-12">
        <div class="search-card">
          <h4 class="search-card-title">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
            </svg>
            {{ t.search.title }}
          </h4>

          <form [formGroup]="form2">
            <div class="row g-3">

              <div class="col-md-6">
                <div class="input-icon-group">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
                  </svg>
                  <input type="text" formControlName="selectedName" class="form-control" [placeholder]="t.search.name" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-icon-group">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="7" width="18" height="12" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                  <select class="form-select" [attr.aria-label]="t.search.businessType" formControlName="selectedBusinessType">
                    <option selected value="" disabled>{{ t.search.businessType }}</option>
                    <option *ngFor="let item of businessType" [value]="item">{{ item }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-icon-group">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2 2 7l10 5 10-5-10-5Z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
                  </svg>
                  <select class="form-select" [attr.aria-label]="t.search.specialityType" formControlName="selectedSpecialityType">
                    <option selected value="" disabled>{{ t.search.specialityType }}</option>
                    <option *ngFor="let item of specialityType" [value]="item">{{ item }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-icon-group">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12Z"/><circle cx="12" cy="10" r="2.5"/>
                  </svg>
                  <select class="form-select" [attr.aria-label]="t.search.location" formControlName="selectedLocation">
                    <option selected value="" disabled>{{ t.search.location }}</option>
                    <option *ngFor="let item of location" [value]="item">{{ item }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-icon-group">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="4" y="3" width="10" height="18"/><rect x="14" y="8" width="6" height="13"/><path d="M8 7h2M8 11h2M8 15h2"/>
                  </svg>
                  <input type="text" formControlName="selectedCity" class="form-control" [placeholder]="t.search.city" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-icon-group">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M9 3 3 5v16l6-2 6 2 6-2V3l-6 2-6-2Z"/><path d="M9 3v16M15 5v16"/>
                  </svg>
                  <select class="form-select" [attr.aria-label]="t.search.state" formControlName="selectedStateType">
                    <option selected value="" disabled>{{ t.search.state }}</option>
                    <option *ngFor="let item of state" [value]="item">{{ item }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-icon-group">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                  <select class="form-select" [attr.aria-label]="t.search.race" formControlName="selectedRace">
                    <option selected value="" disabled>{{ t.search.race }}</option>
                    <option *ngFor="let item of race" [value]="item">{{ item }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="input-icon-group">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="10" cy="14" r="5"/><path d="M13.5 10.5 19 5"/><path d="M14 5h5v5"/>
                  </svg>
                  <select class="form-select" [attr.aria-label]="t.search.gender" formControlName="selectedGender">
                    <option selected value="" disabled>{{ t.search.gender }}</option>
                    <option *ngFor="let item of gender" [value]="item">{{ item }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6 d-flex align-items-center">
                <p class="pledge-note mb-0">
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5l-8-3Z"/><path d="M9 12l2 2 4-4"/>
                  </svg>
                  {{ t.search.pledge }}
                </p>
              </div>

              <div class="col-12">
                <button
                  type="submit"
                  class="btn-search-gradient w-100"
                  (click)="searchCards()"
                  [disabled]="!form2.valid"
                >
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>
                  </svg>
                  {{ t.search.search }}
                </button>
              </div>

            </div>
          </form>

          <div class="search-results" *ngIf="cardsSearched?.length">
            <p class="results-label">{{ t.search.cards }}</p>
            <p
              class="result-item"
              style="cursor: pointer"
              [routerLink]="'/cards/share-card/' + card.id"
              *ngFor="let card of cardsSearched"
            >
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
              </svg>
              {{ card.cardTitle }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ LOGIN / REGISTER ============ -->
<section class="auth-section" id="register">
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-lg-9">
        <div class="text-center mb-4">
          <h2 class="auth-title mb-1">{{ t.auth.heading }}</h2>
          <p class="auth-subtitle">{{ t.auth.subtitle }}</p>
        </div>
        <div class="auth-wrapper">

          <div class="auth-tabs-vertical">
            <div class="auth-tab-vertical" [class.active]="showLoginTab" (click)="checkRoute()">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M11 16l4-4-4-4"/><path d="M15 12H3"/><path d="M13 3h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5"/>
              </svg>
              <span class="tab-text">{{ t.common.login }}</span>
            </div>
            <div class="auth-tab-vertical" [class.active]="!showLoginTab" (click)="checkRoute()">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/><path d="M2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1"/><path d="M19 8v6M22 11h-6"/>
              </svg>
              <span class="tab-text">{{ t.common.register }}</span>
            </div>
          </div>

          <div class="auth-card">
            <div class="tab-content">

              <!-- LOGIN -->
              <div id="login" class="tab-pane auth-form-narrow" [class.active]="showLoginTab">
                <div class="auth-head text-center">
                  <span class="svg-lock d-block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24">
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path fill="var(--pink)" d="M6 22q-.825 0-1.412-.587T4 20V10q0-.825.588-1.412T6 8h1V6q0-2.075 1.463-3.537T12 1t3.538 1.463T17 6v2h1q.825 0 1.413.588T20 10v10q0 .825-.587 1.413T18 22zm0-2h12V10H6zm7.413-3.588Q14 15.826 14 15t-.587-1.412T12 13t-1.412.588T10 15t.588 1.413T12 17t1.413-.587M9 8h6V6q0-1.25-.875-2.125T12 3t-2.125.875T9 6zM6 20V10z" />
                    </svg>
                  </span>
                  <h1 class="auth-title">{{ t.login.welcome }}</h1>
                  <p class="auth-subtitle">{{ t.login.subtitle }}</p>
                </div>

                <form [formGroup]="form">
                  <div class="mb-4">
                    <label class="field-label">{{ t.common.email }} <sup class="req">*</sup></label>
                    <div class="input-icon-group">
                      <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>
                      </svg>
                      <input type="email" id="email" class="form-control" [placeholder]="t.login.emailPlaceholder" formControlName="email" required />
                    </div>
                    <div *ngIf="form.get('email')?.hasError('required') && form.get('email')?.touched" class="text-danger small mt-1">
                      {{ t.login.emailRequired }}
                    </div>
                    <div *ngIf="form.get('email')?.hasError('email') && form.get('email')?.touched" class="text-danger small mt-1">
                      {{ t.login.emailInvalid }}
                    </div>
                  </div>

                  <div class="mb-4">
                    <label class="field-label">{{ t.common.password }} <sup class="req">*</sup></label>
                    <div class="input-icon-group">
                      <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>
                      </svg>
                      <input type="password" id="password" class="form-control" [placeholder]="t.login.passwordPlaceholder" formControlName="password" required />
                    </div>
                    <div *ngIf="form.get('password')?.hasError('required') && form.get('password')?.touched" class="text-danger small mt-1">
                      {{ t.login.passwordRequired }}
                    </div>
                    <div class="forgot-link">
                      <a [routerLink]="['/forgot-password']">{{ t.common.forgotPassword }}</a>
                    </div>
                  </div>

                  <div class="form-check custom-check mb-4">
                    <input type="checkbox" class="form-check-input" id="ageCheckbox">
                    <label class="form-check-label" for="ageCheckbox">{{ t.common.age }}</label>
                  </div>

                  <button (click)="openAgeModal('login')" type="submit" class="btn-pink-gradient w-100 py-3" [disabled]="!form.valid">
                    <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M11 16l4-4-4-4"/><path d="M15 12H3"/><path d="M13 3h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5"/>
                    </svg>
                    {{ t.common.submit }}
                  </button>
                </form>
              </div>

              <!-- REGISTER -->
              <div id="register" class="tab-pane" [class.active]="!showLoginTab">

                <div class="pricing-badge-v2">
                  <div class="pricing-left">
                    <p class="pricing-eyebrow">Starting at</p>
                    <div class="pricing-amount"><span class="amount">$2.54</span><span class="period">/mo</span></div>
                    <p class="pricing-sub">Per Agent</p>
                  </div>
                  <div class="pricing-divider"></div>
                  <div class="pricing-right">
                    <p class="includes-label">Includes:</p>
                    <div class="perk-row">
                      <div class="perk-item">
                        <span class="perk-icon">
                          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20.59 13.41 12 22l-9-9V4a1 1 0 0 1 1-1h9l9 9a2 2 0 0 1 0 2.41Z"/><circle cx="7.5" cy="7.5" r="1.5" fill="currentColor" stroke="none"/>
                          </svg>
                        </span>
                        <span class="perk-text"><strong>40% OFF</strong>all UMYO products</span>
                      </div>
                      <div class="perk-item">
                        <span class="perk-icon">
                          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5"/>
                          </svg>
                        </span>
                        <span class="perk-text"><strong>3 FREE</strong>property listings per agent</span>
                      </div>
                      <div class="perk-item">
                        <span class="perk-icon">
                          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.5" cy="11" r="2"/><path d="M6 16c.5-1.5 1.8-2.3 2.5-2.3s2 .8 2.5 2.3"/><path d="M14 9h4M14 13h4"/>
                          </svg>
                        </span>
                        <span class="perk-text"><strong>FREE</strong>standard CRM integrations</span>
                      </div>
                    </div>
                  </div>
                </div>

                <form [formGroup]="form3">
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="field-label">{{ t.register.firstName }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
                        </svg>
                        <input type="text" [placeholder]="t.register.firstNamePh" formControlName="registerFirstName" class="form-control" required
                          [ngClass]="{'invalid-input': !form3.get('registerFirstName')?.touched && submitButtonClicked && !form3.valid}" />
                      </div>
                    </div>

                    <div class="col-md-6 mb-3">
                      <label class="field-label">{{ t.register.lastName }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
                        </svg>
                        <input type="text" [placeholder]="t.register.lastNamePh" formControlName="registerLastName" class="form-control" required
                          [ngClass]="{'invalid-input': !form3.get('registerLastName')?.touched && submitButtonClicked && !form3.valid}" />
                      </div>
                    </div>

                    <div class="col-md-12 mb-3">
                      <label class="field-label">{{ t.register.phone }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.7a2 2 0 0 1-.5 2.1L8 9.7a16 16 0 0 0 6 6l1.2-1.2a2 2 0 0 1 2.1-.5c.9.3 1.8.5 2.7.6a2 2 0 0 1 1.7 2Z"/>
                        </svg>
                        <input type="text" [placeholder]="t.register.phonePh" formControlName="registerPhone" class="form-control" required
                          [ngClass]="{'invalid-input': !form3.get('registerPhone')?.touched && submitButtonClicked && !form3.valid}" />
                      </div>
                    </div>

                    <div class="col-md-6 mb-3">
                      <label class="field-label">{{ t.common.email }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>
                        </svg>
                        <input type="email" [placeholder]="t.register.emailPh" formControlName="registerEmail" class="form-control" required
                          [ngClass]="{'invalid-input': (!form3.get('registerEmail')?.touched || !form3.get('registerEmail')?.valid) && submitButtonClicked && (!form3.valid || form3.hasError('emailMismatch'))}" />
                      </div>
                    </div>

                    <div class="col-md-6 mb-3">
                      <label class="field-label">{{ t.register.confirmEmail }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/>
                        </svg>
                        <input type="email" [placeholder]="t.register.confirmEmailPh" formControlName="registerConfirmEmail" class="form-control" required
                          [ngClass]="{'invalid-input': (!form3.get('registerConfirmEmail')?.touched || !form3.get('registerConfirmEmail')?.valid) && submitButtonClicked && (!form3.valid || form3.hasError('emailMismatch'))}" />
                      </div>
                    </div>

                    <div class="col-md-12 mb-2">
                      <label class="field-label">{{ t.common.password }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/>
                        </svg>
                        <input [type]="showPassword ? 'text' : 'password'" [placeholder]="t.register.passwordPh" class="form-control" required
                          formControlName="registerPassword"
                          [ngClass]="{'invalid-input': (!form3.get('registerPassword')?.touched || !form3.get('registerPassword')?.valid) && submitButtonClicked && !form3.valid}" />
                        <button type="button" class="password-toggle-btn" (click)="showPassword = !showPassword">
                          <svg *ngIf="!showPassword" class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z"/><circle cx="12" cy="12" r="3"/>
                          </svg>
                          <svg *ngIf="showPassword" class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M9.9 4.24A9.1 9.1 0 0 1 12 4c7 0 11 8 11 8a17.4 17.4 0 0 1-2.36 3.42M6.6 6.6C3.6 8.4 1 12 1 12s4 8 11 8a9.1 9.1 0 0 0 5.4-1.6M1 1l22 22"/>
                          </svg>
                        </button>
                      </div>
                      <div class="password-hint">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="12" cy="12" r="9"/><path d="m9 12 2 2 4-4"/>
                        </svg>
                        {{ t.register.passwordHint }}
                      </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                      <label class="field-label">{{ t.register.businessType }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="3" y="7" width="18" height="12" rx="2"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                        </svg>
                        <select
                          [ngClass]="{'invalid-input': (!form3.get('registerBusinessType')?.touched || !form3.get('registerBusinessType')?.valid) && submitButtonClicked && !form3.valid}"
                          required formControlName="registerBusinessType" class="form-select" [attr.aria-label]="t.register.businessType">
                          <option value="" disabled selected>{{ t.register.pleaseSelect }}</option>
                          <option *ngFor="let item of businessType" [value]="item">{{ item }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                      <label class="field-label">{{ t.register.specialityType }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 2 2 7l10 5 10-5-10-5Z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/>
                        </svg>
                        <select
                          [ngClass]="{'invalid-input': (!form3.get('registerSpecialityType')?.touched || !form3.get('registerSpecialityType')?.valid) && submitButtonClicked && !form3.valid}"
                          required formControlName="registerSpecialityType" class="form-select" [attr.aria-label]="t.register.specialityType">
                          <option value="" disabled selected>{{ t.register.pleaseSelect }}</option>
                          <option *ngFor="let item of specialityType" [value]="item">{{ item }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                      <label class="field-label">{{ t.register.city }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="4" y="3" width="10" height="18"/><rect x="14" y="8" width="6" height="13"/><path d="M8 7h2M8 11h2M8 15h2"/>
                        </svg>
                        <input type="text" formControlName="registerCityType" class="form-control" required
                          [ngClass]="{'invalid-input': !form3.get('registerCityType')?.touched && submitButtonClicked && !form3.valid}" />
                      </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                      <label class="field-label">{{ t.register.race }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                        </svg>
                        <select
                          [ngClass]="{'invalid-input': (!form3.get('registerRaceType')?.touched || !form3.get('registerRaceType')?.valid) && submitButtonClicked && !form3.valid}"
                          required formControlName="registerRaceType" class="form-select" [attr.aria-label]="t.register.race">
                          <option value="" disabled selected>{{ t.register.pleaseSelect }}</option>
                          <option *ngFor="let item of race" [value]="item">{{ item }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                      <label class="field-label">{{ t.register.state }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M9 3 3 5v16l6-2 6 2 6-2V3l-6 2-6-2Z"/><path d="M9 3v16M15 5v16"/>
                        </svg>
                        <select
                          [ngClass]="{'invalid-input': (!form3.get('registerStateType')?.touched || !form3.get('registerStateType')?.valid) && submitButtonClicked && !form3.valid}"
                          required formControlName="registerStateType" class="form-select" [attr.aria-label]="t.register.state">
                          <option value="" disabled selected>{{ t.register.pleaseSelect }}</option>
                          <option *ngFor="let item of state" [value]="item">{{ item }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                      <label class="field-label">{{ t.register.gender }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <circle cx="10" cy="14" r="5"/><path d="M13.5 10.5 19 5"/><path d="M14 5h5v5"/>
                        </svg>
                        <select
                          formControlName="registerGenderType" class="form-select" [attr.aria-label]="t.register.gender"
                          [ngClass]="{'invalid-input': (!form3.get('registerGenderType')?.touched || !form3.get('registerGenderType')?.valid) && submitButtonClicked && !form3.valid}">
                          <option value="" disabled selected>{{ t.register.pleaseSelect }}</option>
                          <option *ngFor="let item of gender" [value]="item">{{ item }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-lg-6 mb-3">
                      <label class="field-label">{{ t.register.location }} <sup class="req">*</sup></label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12Z"/><circle cx="12" cy="10" r="2.5"/>
                        </svg>
                        <select
                          [ngClass]="{'invalid-input': (!form3.get('registerLocation')?.touched || !form3.get('registerLocation')?.valid) && submitButtonClicked && !form3.valid}"
                          required formControlName="registerLocation" class="form-select" [attr.aria-label]="t.register.location">
                          <option value="" disabled selected>{{ t.register.pleaseSelect }}</option>
                          <option *ngFor="let item of location" [value]="item">{{ item }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-12 mb-3">
                      <label class="field-label">{{ t.register.referral }}</label>
                      <div class="input-icon-group">
                        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M20.59 13.41 12 22l-9-9V4a1 1 0 0 1 1-1h9l9 9a2 2 0 0 1 0 2.41Z"/><circle cx="7.5" cy="7.5" r="1.5" fill="currentColor" stroke="none"/>
                        </svg>
                        <input type="text" formControlName="registerReferralCode" class="form-control" />
                      </div>
                    </div>

                    <div class="col-md-12 mb-3">
                      <div class="form-check custom-check">
                        <input type="checkbox" class="form-check-input" id="ageCheckbox2">
                        <label class="form-check-label" for="ageCheckbox2">{{ t.common.age }}</label>
                      </div>
                    </div>
                  </div>

                  <div (click)="submitForm()">
                    <button (click)="openAgeModal('signup')" [disabled]="!form3.valid" class="btn-search-gradient py-3 px-5 d-block mx-auto">
                      <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"/><path d="M2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1"/><path d="M19 8v6M22 11h-6"/>
                      </svg>
                      {{ t.common.submit }}
                    </button>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ FEATURED MEMBERS SLIDER ============ -->
<section class="featured-section">
  <div class="container py-5">
    <div class="d-flex justify-content-between align-items-end mb-4">
      <div>
        <span class="section-kicker">{{ t.featured.kicker }}</span>
        <h3 class="section-heading">{{ t.featured.heading }}</h3>
      </div>
      <a routerLink="/directory" class="view-all-link">
        View All
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"/><path d="M13 5l7 7-7 7"/>
        </svg>
      </a>
    </div>

    <div class="featured-slider">
      <button class="slider-nav prev" (click)="previousFeatured()" aria-label="Previous member">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </button>

      <div class="featured-track">
        <div class="featured-card" *ngFor="let member of featuredMembers">
          <div class="featured-photo">
            <img [src]="member.image" [alt]="member.name">
            <span class="verified-badge" *ngIf="member.verified" title="Verified member">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 6 9 17l-5-5"/>
              </svg>
            </span>
          </div>
          <h5>{{ member.name }}</h5>
          <span class="role">{{ member.role }}</span>
          <p class="location">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12Z"/><circle cx="12" cy="10" r="2.5"/>
            </svg>
            {{ member.location }}
          </p>
          <a [routerLink]="'/profile/' + member.id" class="btn btn-pink-sm">VIEW PROFILE</a>
        </div>
      </div>

      <button class="slider-nav next" (click)="nextFeatured()" aria-label="Next member">
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </button>
    </div>
  </div>
</section>

<!-- ============ ECOSYSTEM CTA ============ -->
<section class="ecosystem-section">
  <div class="container pb-5">
    <div class="ecosystem-card">
      <div class="ecosystem-left">
        <div class="ecosystem-icon">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </div>
        <div>
          <h4>MORE THAN A DIRECTORY.<br><span class="text-pink">WE'RE BUILDING AN ECOSYSTEM.</span></h4>
          <p class="mb-0">Every registration helps us unlock new platforms, create more opportunities, and give back to the community.</p>
        </div>
      </div>
      <a routerLink="/packages" class="btn btn-outline-pink ecosystem-btn">
        SEE WHAT WE UNLOCK TOGETHER
        <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M5 12h14"/><path d="M13 5l7 7-7 7"/>
        </svg>
      </a>
    </div>
  </div>
</section>

<!-- ============ IAM PLEDGE ============ -->
<section class="pledge-section">
  <div class="container py-5">
    <div class="row align-items-center g-5">

      <div class="col-lg-6">
        <span class="section-kicker">{{ t.pledge.kicker }}</span>
        <h3 class="section-heading">{{ t.pledge.heading }}</h3>
        <p class="pledge-lead">{{ t.pledge.lead1 }}</p>
        <p class="pledge-lead">{{ t.pledge.lead2 }}</p>
        <p class="pledge-lead mb-0">{{ t.pledge.lead3 }}</p>
      </div>

      <div class="col-lg-6">
        <div class="pledge-card">
          <span class="pledge-icon">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z"/>
            </svg>
          </span>
          <h4 class="pledge-card-title">{{ t.pledge.cardTitle }}</h4>
          <span class="pledge-card-sub">{{ t.pledge.cardSub }}</span>

          <ul class="pledge-list">
            <li *ngFor="let item of t.pledge.list">
              <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="m9 12 2 2 4-4"/><circle cx="12" cy="12" r="9"/>
              </svg>
              {{ item }}
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</section>

<!-- ============ FOOTER ============ -->
<footer class="site-footer pkg-footer">
  <div class="container-fluid px-3 px-lg-4">
    <div class="row py-5">

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <img src="assets/images/logo.png" alt="UMYO Español" class="brand-logo" onerror="this.style.display='none'">
          <div class="brand-text">UMYO <span class="text-pink">ESPAÑOL</span></div>
        </div>
        <small class="d-block pkg-footer-muted">{{ t.footer.tagline }}</small>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.quickLinks }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/directory">Directory</a></li>
          <li><a routerLink="/packages">Packages</a></li>
          <li><a routerLink="/hardship">Incentives</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
        <h6 class="pkg-footer-heading">{{ t.footer.resources }}</h6>
        <ul class="pkg-footer-links">
          <li><a routerLink="/services">Services</a></li>
          <li><a routerLink="#">How To</a></li>
          <li><a routerLink="/hardship">Hardship Incentives</a></li>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
        </ul>
      </div>

      <div class="col-lg-3 col-md-6">
        <h6 class="pkg-footer-heading">{{ t.footer.connect }}</h6>
        <div class="social-icons justify-content-start">
          <a href="#" aria-label="Instagram">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="TikTok">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 3v11.5a3.5 3.5 0 1 1-3-3.46"/><path d="M14 3c.4 2.6 2.2 4.4 5 4.8"/>
            </svg>
          </a>
          <a href="#" aria-label="YouTube">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="5" width="20" height="14" rx="4"/><path d="M10 9l6 3-6 3V9Z" fill="currentColor" stroke="none"/>
            </svg>
          </a>
          <a href="#" aria-label="Facebook">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3Z"/>
            </svg>
          </a>
          <a href="#" aria-label="X">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4l16 16M20 4 4 20"/>
            </svg>
          </a>
        </div>
      </div>

    </div>

    <div class="pkg-footer-bottom text-center py-3">
      <small>{{ t.footer.copyright }}</small>
    </div>
  </div>
</footer>

<!-- packages modal  -->

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showPackageModal, 'd-block': showPackageModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Select One Package
        </h5>
        <button type="button" class="close" (click)="closePackageModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 70vh; overflow-y: scroll">
        <div class="row">
          <div class="col-md-6" *ngFor="let package of packages; let i = index">
            <div class="outerCard" style="min-height: 30vh; cursor: pointer">
              <div
                class="card"
                [ngClass]="{ cardSelect: selectedPackage === package }"
                (click)="selectPackage(package)"
              >
                <div class="card-body">
                  <h5 class="card-title" style="color: rgb(35, 149, 243)">
                    $
                    {{ package.net_price ? package.net_price : package.price }}
                    <sup
                      style="
                        text-decoration: line-through;
                        font-size: 20px;
                        color: gray;
                        padding-left: 15px;
                      "
                      *ngIf="package.net_price"
                      >{{ package.price }}</sup
                    >
                  </h5>
                  <p class="card-text">Cards Limit: {{ package.limit }}</p>
                  <p class="card-duration">Duration: {{ package.expire_in }}</p>

                  <div
                    class="description-container"
                    style="max-height: 100px; overflow-y: auto"
                  >
                    <p class="card-description">{{ package.description }}</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100" *ngIf="(i + 1) % 2 === 0"></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          (click)="closePackageModal()"
          type="button"
          class="btn btn-secondary"
        >
          Close
        </button>

        <div
          *ngIf="selectedPackage?.price != '0'"
          [ngClass]="{
            hidden: selectedPackage == null || selectedPackage?.price == '0',
            paymentButtons: selectedPackage != null
          }"
        >
          <!-- <div id="paypal-button-container"></div> -->
          <!-- hide stripe -->
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="openStripeModal()"
          >
            Stripe
          </button>
          <!-- <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="paypalClick()"
          >
            paypal
          </button> -->
        </div>
        <div *ngIf="selectedPackage?.price == '0'">
          <button
            type="button"
            style="background-color: rgb(35, 149, 243); color: white"
            class="btn btn-info"
            (click)="continuePaymentButton()"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showLoadingModal, 'd-block': showLoadingModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>{{ paypalTitleMessage }}</h3>
          <p style="padding-top: 15px">{{ paypalMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- stripe modal  -->

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showStripeModal, 'd-block': showStripeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">
          Pay Through Stripe
        </h5>
        <button type="button" class="close"  style="padding-left:10px;padding-right:10px"(click)="closeStripeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <h3>
            Amount
            {{ selectedPackage?.net_price ? selectedPackage?.net_price : selectedPackage?.price }}
          </h3>
          <div class="row" ngxStripeCardGroup>

            <div class="col-md-12" style="padding-top: 17px;">
              <label style="font-size:15px; font-weight:600; padding-bottom:8px; color:var(--text-light); display:block;">Card Number</label>
              <div class="stripe-field-wrapper">
                <ngx-stripe-card-number [options]="cardOptions"></ngx-stripe-card-number>
              </div>
            </div>

            <div class="col-md-6" style="padding-top: 17px;">
              <label style="font-size:15px; font-weight:600; padding-bottom:8px; color:var(--text-light); display:block;">Expiry Date</label>
              <div class="stripe-field-wrapper">
                <ngx-stripe-card-expiry [options]="cardOptions"></ngx-stripe-card-expiry>
              </div>
            </div>

            <div class="col-md-6" style="padding-top: 17px;">
              <label style="font-size:15px; font-weight:600; padding-bottom:8px; color:var(--text-light); display:block;">CVC</label>
              <div class="stripe-field-wrapper">
                <ngx-stripe-card-cvc [options]="cardOptions"></ngx-stripe-card-cvc>
              </div>
            </div>

          </div>
          <div class="row mt-3">
            <div class="col-md-12" style="display:flex; justify-content:center; padding-top:10px;">
              <button type="button" class="btn btn-primary" (click)="pay()">
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeStripeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showAgeModal, 'd-block': showAgeModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>Are You 18+ of your age?</h3>
        </div>
        <p style="padding: 8px">
          You must be at least 13 years old to use the Service. However,
          children of all ages may use the Service and PLTalk Kids (where
          available) if enabled by a parent or legal guardian. Permission by
          Parent or Guardian If you are under 18, you represent that you have
          your parent or guardian’s permission to use the Service. Please have
          them read this Agreement with you. If you are a parent or legal
          guardian of a user under the age of 18, by allowing your child to use
          the Service, you are subject to the terms of this Agreement and
          responsible for your child’s activity on the Service. You can find
          tools and resources to help you manage your family’s experience on
          PLTalk in our Help Center
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="confirmAge()">
          Yes
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeAgeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showLoadingModal, 'd-block': showLoadingModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="container">
          <h3>Confirming Payment...</h3>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showPolicyModal, 'd-block': showPolicyModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="privacyModalLabel">Privacy Policy</h5>
        <button type="button" class="close" (click)="closePolicyModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <pre
            style="
              max-height: 70vh;
              white-space: pre-wrap;
              overflow-x: hidden;
              overflow-y: scroll;
            "
          >
              Privacy Policy
  
  Last modified: January 10, 2022
  
  Who We Are
  
  Welcome! We are UMYO Hispanics   Inc., a Texas corporation, or as we prefer to be known, "UMYO Hispanics  ,"
  "we," "our," or "us." Our mission is to revolutionize how the world connects! We provide
  products,services, and technologies ("Products") allowing users ("Users") to organize,
  display, and share information with their contacts through our software, mobile
  application, and website (collectively,"Platform").
  
  We are committed to safeguarding our User’s privacy in accordance with this Privacy Policy
  ("Policy").Please carefully read this Policy to comprehend our policies and practices
  concerning your information and how we handle it. If you disagree with our policies and
  practices, please refrain from using our Platform or purchasing our Products.
  
  How to Contact Us
  
  If you have any questions about our practices or this Policy, please reach out to us via
  email at data-privacy@UMYO Hispanics  .com or by mail at UMYO Hispanics   Inc., Attn: Data Privacy
  Officer, 1709 Martin Luther King Blvd Dallas, Texas, 75215
  
  Application of this Policy
  
  Upon accessing our Platform or utilizing our Products, you become a User and agree to
  this Policy, our Data Processing Addendum, and our Terms of Service and Sale
  (collectively, "Policies").
  
  This Policy delineates the types of information we may collect from you or that you may
  provide to us when interacting with our Platform or Products. It further outlines
  our practices for collecting,
  using, maintaining, protecting, and disclosing that information.
  
  Categories of Information We Collect or Receive
  
  Our Platform and Products empower Users to customize their pages and profiles by
  uploading and linking content and information, shareable with other Users or third
  parties. The information provided by a User on the Platform can be extensive. We
  may receive information directly from you or automatically as you access, use, or
  interact with our Platform or Products.
  
  The categories of information we collect or receive include:
  
  - **Identity or Contact Information:** Your first name, last name, or similar
   identifier title, postal addresses, unique personal identifiers, online
  identifiers, IP addresses, email addresses, social media accounts or identifiers
  (e.g., username), age, date of birth, or other similar contact information
  or forms of identification.
  
  - **Transaction Information:** Details about payments to and from you, as well
   as other details of subscriptions and services you have purchased from us.
  
  - **Content Data Information:** Any content you post on the Platform, such as
    pictures, third-party links, documents, writings, preference settings, messages,
    comments, and other contributions, along with metadata about them.
  
  - **Marketing and Communications Information:** Your preferences for receiving
    marketing communications from us and your communication preferences.
    Correspondence content, if any, may be retained.
  
  - **Behavioral and Usage Information:** Details of your access, use, or 
    interaction with our Platform or Products, including traffic data, location
    data, logs, and other communication data.
  
  - **Technical Information:** IP address, browser type and version, time zone
    setting and location, browser plug-in types and versions, operating system
    and platform, and other technology on the devices you use to access our Platform.
  
  - **Aggregated Data or Information:** We may collect, use, and share aggregated 
    data or information such as statistical or demographic data derived from your 
    Personal Information.
  
  Because Users can upload various information on our Platform, we may also receive
  sensitive information, such as your date of birth, racial or ethnic origin, sex,
  political views, affiliations, veteran or military status, religious or philosophical
  views, or similar information. We do not mandate the provision of Sensitive Information,
  but such information may be indirectly collected by us through our hosting of the Platform.
  
  Our Platform also allows you to upload and share information that is not Personal Information
  or Sensitive
  Information, such as your hobbies, pictures, links, descriptions, messages, and comments
  ("Other Information"). As our Platform permits you to choose the Information associated
  with your account, we may link Other Information to Personal or Sensitive Information 
  aboutyou.
  
  For more information on our use of cookies, logs, web beacons, and other tracking
  technologies,refer to the "Third-Party Sources, Cookies, and Other Tracking
  Technologies" section below.
  
  Third-Party Sources, Cookies, and Other Tracking Technologies
  
  We may also collect or receive Personal Information from third-party sources, and the Platform
  may include links to other sites. Any Information you provide on linked pages is submitted
  directly to the respective third-party and is subject to their terms and policies. This 
  Policy does not extend to such linked third-party sites, and we disclaim responsibility 
  for the content, privacy, security practices, and policies of these external sites or any
  other sites linked to or from our Platform.
  
  Certain Information on the Platform may be served by third parties, including advertisers,
  ad networks and servers, content providers, and application providers. These third parties
  may utilize cookies independently or in conjunction with web beacons or other tracking
  technologies to collect Information about you. The Information they gather may be linked
  to your Personal Information or Sensitive Information, or they may collect Information,
  including Personal Information, about your activities across different websites and online
  services.This Information may be used to provide you with interest-based advertising or other
  targeted content. We do not oversee third-party tracking technologies or their usage. For 
  inquiries regarding advertisements or other targeted content, please directly contact the 
  responsible provider.
  
  We may collect Information regarding your Platform usage, encompassing the pages and links
  viewed, time spent on our Platform, demographic data such as server locations, connection
  speed, and other non-identifying Information. Like most online services, we employ cookies
  , log files, clear GIFs, tracking pixels, web beacons, and other technologies that may collect
  Personal Information.
  
  Upon visiting our Platform, one or more "cookies" – small data files – may be sent to your
  device to uniquely identify your browser, enabling us to enhance your navigation experience.
  Cookies may convey Information about your Platform or Products usage to provide you with a 
  more personalized experience. Persistent cookies remain on your device after closing your 
  browser, allowing your browser to use them in subsequent visits. These can be removed by 
  following your web browser's instructions. Session cookies are temporary and vanish after 
  closing your browser.Our Platform may utilize the following types of cookies, logs, web
  beacons, and other tracking 
   technology:
  
  - **Essential Cookies:** Necessary to provide you with services available on our Platform, 
  facilitating actions like logging in to secure areas and expediting Content loading.
  
  - **Functionality Cookies:** Allow us to remember your choices, such as login information, 
    providing a more personalized experience.
  
  - **Analytics and Performance Cookies:** Collect Information about traffic to our Platform 
    and Users' interactions to enhance Platform efficiency and gather aggregated, anonymous
    demographic data.
    Third-party tools and services may be utilized for this purpose.
  
  - **Targeted and Advertising Cookies:** Track browsing habits to show relevant content.
   Information about browsing history may group Users with similar interests, enabling
    third-parties to display ads matching those interests.
  
  - **Social Media Cookies:** Activate when sharing or engaging with Content on social
    media platforms,helping track conversions, optimize ads, and build targeted audiences.
  
  - **Log Files:** Automatically reported by your browser, recording information such
   as web requests, IP addresses, browser types, and pages viewed. Servers automatically
  capture this data whenever you access our Platform.
  
  ### How Can I Disable Cookies?
  
  You can typically configure your web browser to block all cookies or prompt you when
  a cookie is being sent.To do this, follow the instructions provided by your browser,
  usually located within the “settings,” “help,” or “tools” function. Many browsers
  are set to accept cookies by default until you modify your settings.
  
  Should you choose not to accept our cookies, it may result in some inconvenience
  during your use of our Platform, and certain features may not operate correctly.
  For instance, we may be unable to recognize your device, necessitating you to log
  in each time you visit our Platform.
  
  For more details on cookies, including viewing and managing cookies on your device, 
  visit www.allaboutcookies.org or www.whatarecookies.com.
  
  As of now, we do not acknowledge web browsers’ “do not track” signals that offer an
  opt-out method from collecting Information about User activities on the Platform.
  If we adopt this practice in the future, relevant information will be provided in
  this Policy.
  
  ### How We Use Your Information
  
  We utilize the Information collected about you or provided by you, including any
  Personal Information:
  
  - To present our Platform and enhance its contents, providing a personalized
    and improved experience for Users.
  - To furnish information, products, or services requested by you, responding
    to inquiries or facilitating purchases 
    and deliveries.
  - To enable your participation in interactive features, allowing the sharing
    of Personal Information with other Users.
  - To send notices regarding your accounts, pages, or subscriptions, including
    expiry and renewal notifications.
  - To fulfill our contractual obligations and enforce rights, including
    billing and collection.
  - To inform you of changes to our Platform, Products, or services.
  - To uphold the safety, security, and integrity of the Platform, Products,
    databases, and technological assets.
  - For testing, research, analysis, and product development, enhancing and
     evolving our Platform and Products.
  - To respond to law enforcement requests and comply with applicable law,
    court orders, or governmental regulations.
  - In any other manner as described when providing the Information or as
     outlined in applicable law, including the CCPA and GDPR.
  - For any other purpose with your consent.
  
  ### Disclosure of Your Information
  
  We may share your Information, including Personal Information, by disclosing
  it to third parties for the provision of our Platform, its Content, and security,
  or for marketing and selling our Platform or Products. 
  These disclosures occur under written contracts specifying purposes,
  confidentiality requirements, and prohibiting use for any purpose other than contract
   performance. We do not sell your Personal Information.
  
  For Users with an account linked to a “UMYO Hispanics   for Teams” subscription, the administrator 
  associated with your “UMYO Hispanics   for Teams” account may manage, access, view, or store your
  Information, including Personal Information. We do not control or limit your account's
  accessibility, and we are not responsible for the administrator's access, disclosure, or
  processing of your Information.
  
  Within the last twelve (12) months, we have disclosed Information, as described in this Policy:
  
  - In connection with your use of our Platform or Products, enabling the sharing of Personal
    Information with other Users.
  - To our service providers, affiliates, agents, subprocessors, advertising partners, 
    internet service providers, data analytics providers, and related third parties, supporting
    Platform and Product functions.
  - To our processors and subprocessors, engaging specific service providers to assist in
     Platform and Product support.
  
  **List of Subprocessors:**
  
  - **Google LLC:** Cloud Service Provider (United States)
  - **Stripe:** Payment Processor (United States)
  - **Hubspot:** Marketing, Sales (CRM), and Support Software Platform (United States)
  - **Chili Piper:** Scheduling Software (United States)
  - **Zapier:** Workflow Integration Software (United States)
  - **Slack:** Messaging and Communication Platform (United States)
  - **Amplitude:** Product and Data Analytics (United States)
  - **Shopify:** Ecommerce Platform (Canada and jurisdictions per Shopify’s policies)
  - **Cloudflare Inc.:** Web Traffic Optimization and Distribution Service (United States)
  - **Covve Visual Network Limited:** Physical business card scanner API (Cyprus)
  - **Rollbar:** Error Monitoring (United States)
  - **Heroku:** Cloud Hosting Provider (United States)
  - **AWS:** Cloud Hosting Provider (United States)
  - **Fivetran:** ETL Tooling (United States)
  - **Looker:** BI (Business Intelligence) tooling (United States)
  - **Cloudinary:** Image hosting API (United States)
  - **Newrelic:** APM (Application Performance Monitoring) (United States)
  - **Passsource:** API (United States)
  - **Klaviyo:** Marketing automation (United States)
  
  **User Data Privacy Policy**
  
  **Effective Date: [Date]**
  
  Welcome to UMYO Hispanics  ! This User Data Privacy Policy ("Policy") outlines how we collect,
  use, disclose, and protect your information when you use our platform, products, and
  services ("Platform" or "Products"). Please read this Policy carefully to understand
  our practices regarding your information and how we will treat it.
  
  ### 1. **How Can I Disable Cookies?**
  
  You have the ability to configure your web browser to block cookies or prompt
  you when a cookie is being sent. Refer to your browser's settings, usually
  located in the "settings," "help," or "tools" function. Please note that
  if you choose to disable our cookies, it may impact your experience on the Platform,
  and certain features may not operate correctly. For more information on cookies,
  including how tomanage them, visit [www.allaboutcookies.org](www.allaboutcookies.org)
  or [www.whatarecookies.com](www.whatarecookies.com).
  
  As of now, we do not acknowledge "do not track" signals from web browsers. If this
  changes in the future, we will provide relevant information in this Policy.
  
  ### 2. **How We Use Your Information**
  
  We use the information collected or provided by you for various purposes, including
  but not limited to:
  
  - Presenting and enhancing the Platform.
  - Providing information, products, or services as requested.
  - Enabling participation in interactive features and sharing information with other Users.
  - Sending notices regarding accounts, pages, or subscriptions.
  - Fulfilling contractual obligations, including billing and collection.
  - Informing you of changes to our Platform, Products, or services.
  - Upholding the safety, security, and integrity of our Platform and Products.
  - Conducting testing, research, analysis, and product development.
  - Responding to law enforcement requests and complying with applicable laws.
  
  ### 3. **Disclosure of Your Information**
  
  We may share your information, including Personal Information, with third parties for various 
  purposes,such as providing our Platform, securing it, and marketing or selling our Products.
  These disclosures are governed by written contracts specifying purposes and confidentiality
  requirements. We do not sell your Personal Information.
  
  **List of Subprocessors:**
  - Google LLC (Cloud Service Provider, United States)
  - Stripe (Payment Processor, United States)
  - Hubspot (Marketing, Sales, and Support Software Platform, United States)
  - Chili Piper (Scheduling Software, United States)
  - Zapier (Workflow Integration Software, United States)
  - Slack (Messaging and Communication Platform, United States)
  - Amplitude (Product and Data Analytics, United States)
  - Shopify (Ecommerce Platform, Canada and jurisdictions per Shopify’s policies)
  - Cloudflare Inc. (Web Traffic Optimization and Distribution Service, United States)
  - Covve Visual Network Limited (Physical business card scanner API, Cyprus)
  - Rollbar (Error Monitoring, United States)
  - Heroku (Cloud Hosting Provider, United States)
  - AWS (Cloud Hosting Provider, United States)
  - Fivetran (ETL Tooling, United States)
  - Looker (BI tooling, United States)
  - Cloudinary (Image hosting API, United States)
  - Newrelic (APM, United States)
  - Passsource (API, United States)
  - Klaviyo (Marketing automation, United States)
  
  ### 4. **Where We Store Your Information**
  
  We maintain our Platform in the United States, and your information may be stored,
  processed, and accessed in the U.S. or elsewhere by us, our employees, contractors,
  and third parties. By using our Platform and providing your information, you consent
  to the export of Personal Information to the United States, understanding that U.S.
  laws may differ from those in your country.
  
  ### 5. **How Long We Store Your Information**
  
  We retain your information for as long as reasonably necessary for the purposes
  outlined in this Policy, unless a longer retention period is required by law. We
  may keep your information for business interests, audits, legal compliance, dispute
  resolution, and agreement enforcement.
  
  ### 6. **Your Rights Related to Your Personal Information**
  
  You may have rights under laws such as the CCPA and GDPR. These rights may include:
  
  - Requesting access to your Personal Information.
  - Right to Know (CCPA) – Receiving information about the collection and use of your
     Personal Information.
  - Requesting correction of your Personal Information.
  - Requesting erasure of your Personal Information.
  - Objecting to processing or requesting restriction of processing.
  - Requesting the transfer of your Personal Information.
  - Withdrawing consent.
  
  ### 7. **How to Exercise Your Rights**
  
  To exercise your rights or inquire about your Personal Information, contact us at 
  [data-privacy@UMYO Hispanics  .com] (mailto:data-privacy@UMYO Hispanics  .com) or by mail at
  UMYO Hispanics   Inc., Attn: Data Privacy Officer, [Address].
  
  We will confirm receipt of your request within ten (10) business days and aim to
  respond within one month, unless the request is complex. If applicable, any disclosures
  will cover the 12-month period preceding the request.
  
  ### 8. **Non-Discrimination**
  
  We do not discriminate against you for exercising your rights. We will not deny goods or
  services, charge different prices, or provide different quality levels based on your
  exercise of privacy rights, unless permitted by law.
  
  ### 9. **How We Protect Your Information**
  
  We implement measures to secure your information from loss and unauthorized access.
  All information is stored on secure servers, and payment transactions are encrypted
  using SSL technology.
  
  ### 10. **Children Under the Age of 16**
  
  Our Platform is not intended for children under 16. We do not knowingly collect
  Personal Information from children under 16. If you are under 16, please do not
  use the Platform or provide any information. If we learn of such information, we
  will delete it promptly.
  
  ### 11. **Opting Out of Sale of Personal Information**
  
  We do not sell Personal Information. If you are 16 or older, you can direct us not
  to sell your information at any time by contacting us at 
  [data-privacy@UMYO Hispanics  .com](mailto:data-privacy@UMYO Hispanics  .com) or by mail at
  UMYO Hispanics   Inc., Attn: Data Privacy Officer, 1709 MLK BLVD Dallas, Texas 75215
  
  **Changes to Our Privacy Policy at UMYO Hispanics  **
  
  You acknowledge that this Policy is subject to modification by us at any time,
  without prior written notice,and solely at our discretion. Any revisions to this
  Policy will take effect on the "Last Updated Date" or "Last Revised Date"
  indicated on the Platform. Therefore, it is advisable to review our Policies before
  making any purchases or using our Products, Platform, or associated services. Your
  ongoing use of the Platform or any Product following the "Last Updated Date" or "Last
  Revised Date" will signify your acceptance and agreement to these modifications
  
            </pre
          >
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showRefundModal, 'd-block': showRefundModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="refundModalLabel">Refund Policy</h5>
        <button type="button" class="close" (click)="closeRefundModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <pre
            style="
              max-height: 70vh;
              white-space: pre-wrap;
              overflow-y: scroll;
              overflow-x: hidden;
            "
          >
              **Refund Policy at UMYO Hispanics  **
  
  **Returns for Defective Items:**
  Our steadfast commitment to delivering high-quality custom items remains unwavering. In the
  event that you receive a defective or damaged item, kindly notify us within 30 days of
  receipt. We will promptly offer a replacement or a full refund for the returned items.
  
  **Return for Customization Issues:**
  If the item received does not align with the agreed-upon customization specifications,
  please inform us within 30 days of receipt. We will collaborate with you to replace
  and reprint it correctly to your satisfaction. In some cases, we may request the return
  of the item to our office to address any issues that occurred during the printing process.
  
  **No Returns for Change of Mind:**
  Due to the personalized nature of our custom items, returns or exchanges stemming from a
  change of mind are not feasible. We encourage you to thoroughly review all customization
  details before confirming your order. This enables us to promptly commence crafting your
  item, ensuring a smooth and efficient process.
  
  **Communication on Specifications:**
  To expedite the process and ensure your custom item exceeds expectations, we rely on
  comprehensive and precise specifications during the ordering process. Your timely
  and detailed communication allows us to swiftly proceed with crafting your custom
  piece, reflecting our commitment to your satisfaction.
  
  If you believe your order requires additional details, please notify us promptly.
  As the fastest custom NFC option on the market, early communication enhances our
  ability to address any potential issues.
  
  **Cancellation Policy:**
  You can cancel your order within 1-2 business days of purchase, provided we haven't
  initiated the creation of your custom item. If cancellation is requested after this
  timeframe, a 10% cancellation fee will be applied to cover the cost of materials and
  work invested in your unique item. This fee will be deducted from your refund.
  
            </pre
          >
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngClass]="{ show: showTermsModal, 'd-block': showTermsModal }"
  style="background-color: rgb(0, 0, 0, 0.8)"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="termsModalLabel">Terms Of Service</h5>
        <button
          type="button"
          class="close"
          (click)="closeTermsModal()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
          <pre
            style="
              max-height: 70vh;
              white-space: pre-wrap;
              overflow-y: scroll;
              overflow-x: hidden;
            "
          >
              Welcome to UMYO Hispanics  !
  
  **Terms of Service and Sale - UMYO Hispanics  **
  
  **Last Revised: December 22, 2023**
  
  **Terms of Sale and Service**
  
  **Introduction**
  
  Welcome! We are UMYO Hispanics  , a Delaware corporation, known as "we," "our," or "us." Our mission
  is to redefine how the world connects. We provide Products, Services, and Technologies
  ("Products") that enable Users ("Users") to organize, display, and share information
  with others and third parties ("Services") through our software, mobile application, and
  website (collectively, "Platform").
  
  By submitting an order through the Platform or otherwise ("Order"), you (whether on behalf
  of yourself or an entity you represent) are entering into these Terms of Sale and Service
  ("Terms") with us. You agree to be bound by these Terms and other conditions governing the
  use of our Services, Platform, or the Products offered or sold, such as our Privacy Policy
  and Data Processing Addendum (collectively, "Policies"). If you are under 16, you may not
  use our Platform or Services without parental or guardian permission.
  
  If you disagree with these Terms or our Policies, do not submit an Order or use our
  Platform, Services, or Products.
  
  By agreeing, you confirm that you have the authority to bind yourself and/or the entity
  or company you represent. We may periodically modify these Terms or any Policies at our
  discretion, with the "Last Revised" date indicating such changes.
  
  **Purchase of Products**
  
  (a) When you place an Order, you make an offer to purchase Products according to the
  Order terms, these Terms, and our Policies. An Order is effective upon our acceptance
  or rejection. We may accept or reject Orders at our discretion. Product prices (the
  "Product Purchase Price") are as stated in the Order or, if not in an Order, as
  advertised on our Platform when we accept the Order. Prices exclude taxes; you are
  responsible for such charges.
  
  (b) We select shipment methods and carriers unless specified in the Order. Partial
  shipments are possible at our discretion. You pay for shipped units, including shipping
  and insurance costs unless otherwise stated in the Order.
  
  (c) Products will be delivered to the specified address ("Delivery Point") within a
  reasonable time. Custom Products may have longer processing times. Delivery times are
  estimates, and we are not liable for delays. Title and risk pass upon delivery. If you
  fail to accept delivery, risk passes to you, and we may store the Products at your cost.
  
  (d) Inspect Products within ten (10) days of delivery ("Inspection Period"). Accept or reject
  Nonconforming Products (materially different or defective) during the Inspection Period. If
  notified of Nonconforming Products, ship them to us, and we may replace them.
  
  (e) We warrant Products against significant defects for 1 year ("Warranty Period"). The
  warranty doesn't apply if Products are misused, altered, or used with unauthorized hardware.
  Except for this warranty, we provide no other warranties.
  
  (f) We are not liable for a breach of the warranty unless you give written notice within
  10 days of discovering the defect, allow us to examine the Products, and we verify the
  Nonconforming Products. Remedies for Nonconforming Products are repair, replacement,
  credit, or refund at our discretion.
  
  (g) Your sole remedy for Nonconforming Products is as outlined in Section 2(f).
  
  (h) Changes to Terms in Orders are void unless expressly stated.
  
  **Services**
  
  (a) To use our Services, register and create an account ("Account"). Our Services allow
  Users to create, design, maintain, and share profiles or pages ("Pages"). Subscription
  Levels offer different access levels.
  
  (b) During the Subscription Term, you are granted licensed seats for Services based on
  an accepted Order. Users are responsible for complying with these Terms and our Policies.
  Some Products may require an Account Administrator.
  
  (c) We may establish policies and practices for the Platform, including deleting or
  removing Content, terminating inactive Accounts, or changing Services. Our Services
  may be changed, suspended, or discontinued at any time.
  
  (d) You are responsible for your Account's security. Notify us of any unauthorized
  use promptly. We are not liable for third-party access resulting from your failure
  to comply with these Terms.
  
  **Subscription; Payment Terms**
  
  (a) We offer various Subscription Levels with associated Subscription Fees. Fees
  are subject to change, impacting renewals but not current Subscription Terms.
  
  (b) You agree to pay Subscription Fees associated with your Subscription. Payment
   terms are as stated on our Platform or Order.
  
  (c) We may collect payments through third-party processors. By providing payment
  information, you authorize us to charge your payment method for Fees. Failure to
  verify or accept your payment method may result in suspension or cancellation.
  
  (d) Subscription Fees may consist of recurring charges. By choosing a recurring
  payment plan, you acknowledge and accept responsibility for all recurring charges.
  
  (e) We may submit periodic charges without further authorization until notice of
  termination or payment method change is provided. Charges submitted before notice will
  not be affected.
  
  (f) Your subscription will automatically renew unless terminated before the end of
  the then-current Subscription Term. Termination may occur through Account settings.
  No refunds are provided for early termination.
  
  Certainly! Here's the rewritten version:
  
  ---
  
  **UMYO Hispanics   App Terms of Service**
  
  **1. Account Information and Updates**
  
  (g) You must provide accurate, current, and complete information for your UMYO Hispanics  
  account. Ensure timely updates for your billing account, including changes to
  billing address, credit card number, or expiration date. Promptly notify us or
  our payment processor about canceled payment methods or potential security breaches.
  Make changes through your account settings. Failure to provide accurate information
  authorizes us to continue charging subscription fees.
  
  **2. Free Trials and Subscriptions**
  
  (h) Free trials for paid subscription levels are offered with specific terms disclosed
   during the offer. Trials are for users without prior paid subscriptions. Obtaining a
  free tier allows one account creation. Non-genuine use may result in standard fees or
   service denial. Acceptance of free trial subscription implies agreement to associated
    fees upon expiration unless canceled.
  
  **3. User-Generated Content**
  
  (a) Users can post content ("Content") on UMYO Hispanics  . Posted Content is not confidential,
   treated as public information. By posting, users represent having the right to do so
  and grant us a non-exclusive license to use it for platform operation and promotion.
  
  (b) Users warrant that Content doesn't infringe third-party rights. We reserve the
   right to review and may refuse or remove Content violating terms, policies, or
  laws. Prohibited actions include unlawful, harmful, or objectionable Content;
  collecting personal information without consent; creating derivative works; and
  interfering with platform operations.
  
  (c) The platform may contain links to third-party services ("Third Party
  Services"). These services are not covered by our terms, and we are not
  responsible for them.
  
  (d) Platform content is protected by intellectual property laws. All related
  rights are exclusively ours. Users providing feedback grant us rights to use it freely.
  
  **4. Limitation on Liability**
  
  (a) We're not liable for user-posted Content, user interactions, losses from platform
  use, negative comments, or third-party information provided without consent. Users are
  responsible for interactions with others; we may not intervene in disputes.
  
  (b) We're not liable for indirect, incidental, or exemplary damages arising from a
   breach of terms, regardless of foreseeability. Our aggregate liability is limited
  to the total amounts paid by you in the previous 12 months.
  
  **5. Indemnification**
  
  Users indemnify us against any losses arising from claims by third parties related to
  platform use, purchased products or services, or user negligence or breach of terms.
  
  **6. Governing Law**
  
  These terms are governed by the laws of the State of Alabama.
  
  **7. Binding Arbitration**
  
  (a) By accepting these terms, you waive the right to a jury trial and class action
  participation. Disputes are resolved through binding arbitration. Some claims are
  exempted, including those regarding intellectual property rights or small claims.
  
  (b) Disputes must be addressed informally for at least 30 days before arbitration.
  If unresolved, either party may elect binding arbitration administered by the
  American Arbitration Association in Birmingham, Alabama.
  
  **8. General**
  
  (a) Unenforceability of one provision won't affect others. In case of conflict,
  we decide which provision prevails. Headings are for convenience. Our
  non-enforcement doesn't waive future enforcement rights.
  
  (b) Products and services may be subject to US export control laws. Users
   are responsible for compliance. Communication with us is electronic,
   fulfilling legal requirements.
  
  (c) Notices are provided within the platform or through services. Users
    can notify us via mail.
  
  (d) "Include" or "including" is not limiting, and "or" means "and/or."
  
  ---
  
            </pre
          >
        </div>
      </div>
    </div>
  </div>
</div>
